import { apiFetch } from './client';
import type { UserPreferencesResponse, UserPreferencesV1 } from '@/lib/user-preferences';

export type UpdateUserPreferencesPayload = Partial<
  Pick<UserPreferencesV1, 'general' | 'financial'>
>;

export const userPreferencesApi = {
  get(): Promise<UserPreferencesResponse> {
    return apiFetch<UserPreferencesResponse>('/users/me/preferences');
  },

  save(payload: UpdateUserPreferencesPayload): Promise<UserPreferencesResponse> {
    return apiFetch<UserPreferencesResponse>('/users/me/preferences', {
      method: 'POST',
      body: payload,
    });
  },

  patch(payload: UpdateUserPreferencesPayload): Promise<UserPreferencesResponse> {
    return apiFetch<UserPreferencesResponse>('/users/me/preferences', {
      method: 'PATCH',
      body: payload,
    });
  },
};
